import React, { useCallback, useState, useEffect } from 'react';
import { uploadPhotoIdWeb } from 'common/appInterface';

const PhotoUploadTest = (props) => {

  const callback = useCallback(() => {
      props.setMain(true);
  }, [props]);

  const [idType, setIdType] = useState("1");
  const [photoType, setPhotoType] = useState("1");
  const [returnIdType, setReturnIdType] = useState("");
  const [returnPhotoType, setReturnPhotoType] = useState("");
  const [returnImageValue, setReturnImageValue] = useState("");

  // uploadPhotoID_Web 처리 (WEB > APP)
  const uploadPhoto = useCallback(() => {
    uploadPhotoIdWeb(idType, photoType);
  }, [idType, photoType]);

  // completedPhotoID_App 처리 (APP > WEB)
  const completedPhotoApp = useCallback((event) => {
    setReturnIdType(event.detail.idType);
    setReturnPhotoType(event.detail.photoType);
    setReturnImageValue(event.detail.imageValue);
    alert("completedPhotoID_App catch...");
  }, []);

  // APP이벤트 공통 수신처리 (APP > WEB)
  useEffect(() => {
    document.addEventListener("backpress", callback);
    return () => document.removeEventListener("backpress", callback);
  }, [callback]);

  // APP이벤트 공통 수신처리 (APP > WEB)
  useEffect(() => {
    document.addEventListener("idUpload", completedPhotoApp);
    return () => document.removeEventListener("idUpload", completedPhotoApp);
  }, [completedPhotoApp]);

  return (
    <div id="container">
      <section className="contents">
        <div className="singUpWrapSub">
          <div className="txtWrap">
            <p className="mainTxt">uploadPhotoID_Web</p>
          </div>
          <div className="conWrap mgt30">
            <div className="inputBoxWrapTy01" style={{overflow: "initial"}}>
              <div className="inputBoxTy01 formSelectBoxTy02">
                <label className="mgb20" style={{margin: "0 0 45px", position: "relative", display: "inline-block", width: "100%"}}>
                  <select style={{padding: "10px 0"}} value={idType} onChange={(e) => setIdType(e.target.value)}>
                    <option value="1">[1] 주민등록증</option>
                    <option value="2">[2] 운전면허증</option>
                    <option value="3">[3] 외국인등록증</option>
                    <option value="4">[4] 여권</option>
                  </select>
                  <span style={{opacity: ".5", transform: "scale(0.75) translateY(-80%) translateX(0px)", transformOrigin: "left", padding: "10px 0", fontSize: "18px", pointerEvents: "none", position: "absolute", left: "0", top: "0", transition: "0.2s", transitionTimingFunction: "cubic-bezier(0.25, 0.1, 0.25, 1)"}}>idType</span>
                </label>
              </div>
              <div className="inputBoxTy01 formSelectBoxTy02">
                <label className="mgb20" style={{margin: "0 0 45px", position: "relative", display: "inline-block", width: "100%"}}>
                  <select style={{padding: "10px 0"}} value={photoType} onChange={(e) => setPhotoType(e.target.value)}>
                    <option value="1">[1] FRONT</option>
                    <option value="2">[2] BACK</option>
                    <option value="3">[3] SELFIE</option>
                  </select>
                  <span style={{opacity: ".5", transform: "scale(0.75) translateY(-80%) translateX(0px)", transformOrigin: "left", padding: "10px 0", fontSize: "18px", pointerEvents: "none", position: "absolute", left: "0", top: "0", transition: "0.2s", transitionTimingFunction: "cubic-bezier(0.25, 0.1, 0.25, 1)"}}>photoType</span>
                </label>
              </div>
            </div>
            <div className="btnWrapTy01">
              <button type="button" className="btnPrimaryTy01" onClick={uploadPhoto}><span>uploadPhotoID_Web Call</span></button>
            </div>
          </div>
        </div>
        <div className="singUpWrapSub">
          <div className="txtWrap">
            <p className="mainTxt">completedPhotoID_App</p>
          </div>
          <div className="conWrap mgt30">
            <div className="inputBoxWrapTy01" style={{overflow: "initial"}}>
              <div className="inputBoxTy01"> 
                <label className="mgb20">
                  <input type="text" value={returnIdType} readOnly />
                  <span>idType</span>
                </label>
              </div>
              <div className="inputBoxTy01"> 
                <label className="mgb20">
                  <input type="text" value={returnPhotoType} readOnly />
                  <span>photoType</span>
                </label>
              </div>
            </div>
            <div className="textareaBox mgb120"> 
              <label className="" style={{margin: "0 0 45px", position: "relative", display: "inline-block", width: "100%"}}>
                <textarea type="text" value={returnImageValue} readOnly style={{marginTop: "10px", padding: "5px 10px"}} />
                <span style={{opacity: ".5", transform: "scale(0.75) translateY(-80%) translateX(0px)", transformOrigin: "left", padding: "10px 0", fontSize: "18px", pointerEvents: "none", position: "absolute", left: "0", top: "0", transition: "0.2s", transitionTimingFunction: "cubic-bezier(0.25, 0.1, 0.25, 1)"}}>imageValue</span>
              </label>
            </div>
          </div>
        </div>
      </section>
      <div className="btnArea">
        <div className="btnWrapTy01">
          <button type="button" className="btnPrimaryTy01 mgb60" onClick={callback}><span>메뉴복귀</span></button>
        </div>
      </div>
    </div>
  );
}

export default PhotoUploadTest;